import dispatchEvent from '../utils/dispatch-event';
import onDocumentReady from '../utils/on-document-ready';

class QuantitySelector extends HTMLElement {
  constructor() {
    super();

    onDocumentReady(() => {
      this.initEventListeners();
    });
  }

  get decrementButton() {
    return this.querySelector('[data-decrement]');
  }

  get incrementButton() {
    return this.querySelector('[data-increment]');
  }

  get productId() {
    return this.dataset.productId;
  }

  get variantId() {
    return this.dataset.variantId;
  }

  get lineItemKey() {
    return this.dataset.lineItemKey;
  }

  get currentQuantity() {
    return Number(this.querySelector('[data-quantity]').innerText);
  }

  get lineItemPrice() {
    return Number(this.dataset.lineItemPrice);
  }

  get inventory() {
    return this.dataset.lineItemInventory;
  }

  changeQuantity(newQuantity) {
    // Use line item key for precise updates (prevents duplicate line items)
    const updateKey = this.lineItemKey || this.variantId;
    return fetch(`/cart/update.js?updates[${updateKey}]=${newQuantity}`).then(
      async response => {
        // Validation failure (stock or quantity limit rules) - the cart is
        // unchanged, so show the message against this line instead of re-rendering
        if (response.status === 422) {
          const { description, message } = await response.json();
          this.showError(description || message);
          return;
        }

        dispatchEvent('cart:quantity-updated', document);
      }
    );
  }

  showError(message) {
    const error = this.closest('[data-cart-item]')?.querySelector(
      '[data-cart-item-error]'
    );

    if (!error) return;

    error.textContent = message;
    error.classList.remove('hidden');
  }

  increment() {
    if (
      this.inventory === 'preorder' ||
      this.inventory > this.currentQuantity
    ) {
      this.changeQuantity(this.currentQuantity + 1);
    }
  }

  decrement() {
    this.changeQuantity(Math.max(0, this.currentQuantity - 1));
  }

  initEventListeners() {
    this.decrementButton.addEventListener('click', () => this.decrement());
    this.incrementButton.addEventListener('click', () => this.increment());
  }
}

customElements.define('quantity-selector', QuantitySelector);
